// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__8kQYu","transparentBlack":"styles_transparentBlack__TIPBd","transparentWhite":"styles_transparentWhite__S50pz"};